// All locations within 30km of Oostham (Tessenderlo-Ham area)
export const LOCATIONS = [
  // Limburg - Core area
  { slug: 'tessenderlo', name: 'Tessenderlo', province: 'Limburg' },
  { slug: 'ham', name: 'Ham', province: 'Limburg' },
  { slug: 'leopoldsburg', name: 'Leopoldsburg', province: 'Limburg' },
  { slug: 'beringen', name: 'Beringen', province: 'Limburg' },
  { slug: 'heusden-zolder', name: 'Heusden-Zolder', province: 'Limburg' },
  { slug: 'houthalen-helchteren', name: 'Houthalen-Helchteren', province: 'Limburg' },
  { slug: 'lummen', name: 'Lummen', province: 'Limburg' },
  { slug: 'halen', name: 'Halen', province: 'Limburg' },
  { slug: 'zonhoven', name: 'Zonhoven', province: 'Limburg' },
  { slug: 'hasselt', name: 'Hasselt', province: 'Limburg' },
  { slug: 'genk', name: 'Genk', province: 'Limburg' },
  { slug: 'diepenbeek', name: 'Diepenbeek', province: 'Limburg' },
  { slug: 'peer', name: 'Peer', province: 'Limburg' },
  { slug: 'pelt', name: 'Pelt', province: 'Limburg' },
  { slug: 'lommel', name: 'Lommel', province: 'Limburg' },
  { slug: 'bocholt', name: 'Bocholt', province: 'Limburg' },
  { slug: 'hamont-achel', name: 'Hamont-Achel', province: 'Limburg' },
  { slug: 'bree', name: 'Bree', province: 'Limburg' },
  { slug: 'kinrooi', name: 'Kinrooi', province: 'Limburg' },
  { slug: 'maaseik', name: 'Maaseik', province: 'Limburg' },
  { slug: 'dilsen-stokkem', name: 'Dilsen-Stokkem', province: 'Limburg' },
  { slug: 'as', name: 'As', province: 'Limburg' },
  { slug: 'opglabbeek', name: 'Opglabbeek', province: 'Limburg' },
  { slug: 'zutendaal', name: 'Zutendaal', province: 'Limburg' },
  { slug: 'lanaken', name: 'Lanaken', province: 'Limburg' },
  { slug: 'bilzen', name: 'Bilzen', province: 'Limburg' },
  { slug: 'hoeselt', name: 'Hoeselt', province: 'Limburg' },
  { slug: 'riemst', name: 'Riemst', province: 'Limburg' },
  { slug: 'tongeren', name: 'Tongeren', province: 'Limburg' },
  { slug: 'borgloon', name: 'Borgloon', province: 'Limburg' },
  { slug: 'sint-truiden', name: 'Sint-Truiden', province: 'Limburg' },
  { slug: 'nieuwerkerken', name: 'Nieuwerkerken', province: 'Limburg' },
  { slug: 'gingelom', name: 'Gingelom', province: 'Limburg' },
  { slug: 'kortenaken', name: 'Kortenaken', province: 'Limburg' },
  { slug: 'alken', name: 'Alken', province: 'Limburg' },
  { slug: 'wellen', name: 'Wellen', province: 'Limburg' },
  { slug: 'kortessem', name: 'Kortessem', province: 'Limburg' },
  { slug: 'herstappe', name: 'Herstappe', province: 'Limburg' },
  { slug: 'voeren', name: 'Voeren', province: 'Limburg' },
  { slug: 'maasmechelen', name: 'Maasmechelen', province: 'Limburg' },
  
  // Antwerpen Province - nearby
  { slug: 'meerhout', name: 'Meerhout', province: 'Antwerpen' },
  { slug: 'geel', name: 'Geel', province: 'Antwerpen' },
  { slug: 'mol', name: 'Mol', province: 'Antwerpen' },
  { slug: 'balen', name: 'Balen', province: 'Antwerpen' },
  { slug: 'dessel', name: 'Dessel', province: 'Antwerpen' },
  { slug: 'retie', name: 'Retie', province: 'Antwerpen' },
  { slug: 'laakdal', name: 'Laakdal', province: 'Antwerpen' },
  { slug: 'westerlo', name: 'Westerlo', province: 'Antwerpen' },
  { slug: 'herselt', name: 'Herselt', province: 'Antwerpen' },
  { slug: 'hulshout', name: 'Hulshout', province: 'Antwerpen' },
  { slug: 'herentals', name: 'Herentals', province: 'Antwerpen' },
  { slug: 'olen', name: 'Olen', province: 'Antwerpen' },
  { slug: 'herenthout', name: 'Herenthout', province: 'Antwerpen' },
  { slug: 'vorselaar', name: 'Vorselaar', province: 'Antwerpen' },
  { slug: 'lille', name: 'Lille', province: 'Antwerpen' },
  { slug: 'kasterlee', name: 'Kasterlee', province: 'Antwerpen' },
  { slug: 'turnhout', name: 'Turnhout', province: 'Antwerpen' },
  { slug: 'arendonk', name: 'Arendonk', province: 'Antwerpen' },
  { slug: 'ravels', name: 'Ravels', province: 'Antwerpen' },
  
  // Vlaams-Brabant - nearby
  { slug: 'diest', name: 'Diest', province: 'Vlaams-Brabant' },
  { slug: 'scherpenheuvel-zichem', name: 'Scherpenheuvel-Zichem', province: 'Vlaams-Brabant' },
  { slug: 'bekkevoort', name: 'Bekkevoort', province: 'Vlaams-Brabant' },
  { slug: 'aarschot', name: 'Aarschot', province: 'Vlaams-Brabant' },
  { slug: 'begijnendijk', name: 'Begijnendijk', province: 'Vlaams-Brabant' },
  { slug: 'rotselaar', name: 'Rotselaar', province: 'Vlaams-Brabant' },
  { slug: 'tremelo', name: 'Tremelo', province: 'Vlaams-Brabant' },
  { slug: 'keerbergen', name: 'Keerbergen', province: 'Vlaams-Brabant' },
  { slug: 'haacht', name: 'Haacht', province: 'Vlaams-Brabant' },
  { slug: 'boortmeerbeek', name: 'Boortmeerbeek', province: 'Vlaams-Brabant' },
  { slug: 'tielt-winge', name: 'Tielt-Winge', province: 'Vlaams-Brabant' },
  { slug: 'lubbeek', name: 'Lubbeek', province: 'Vlaams-Brabant' },
  { slug: 'holsbeek', name: 'Holsbeek', province: 'Vlaams-Brabant' },
  { slug: 'tienen', name: 'Tienen', province: 'Vlaams-Brabant' },
  { slug: 'linter', name: 'Linter', province: 'Vlaams-Brabant' },
  { slug: 'zoutleeuw', name: 'Zoutleeuw', province: 'Vlaams-Brabant' },
  { slug: 'geetbets', name: 'Geetbets', province: 'Vlaams-Brabant' },
  { slug: 'leuven', name: 'Leuven', province: 'Vlaams-Brabant' },
];

// Service types
export const SERVICE_TYPES = {
  algemeen: {
    title: 'Renovaties',
    titleFull: 'Renovaties & Verbouwingen',
    description: 'totaalrenovaties, verbouwingen en interieurprojecten',
    keywords: 'renovatie, verbouwing, totaalrenovatie, interieur, aannemer',
  },
  badkamer: {
    title: 'Badkamerrenovatie',
    titleFull: 'Badkamer Renoveren',
    description: 'badkamerrenovaties met inloopdouche, vrijstaand bad en modern sanitair',
    keywords: 'badkamer renovatie, badkamer verbouwen, inloopdouche, sanitair, badkamer op maat',
  },
  keuken: {
    title: 'Keukenrenovatie', 
    titleFull: 'Keuken Renoveren',
    description: 'keukenrenovaties met kookeiland, maatwerk en moderne apparatuur',
    keywords: 'keuken renovatie, keuken verbouwen, kookeiland, keuken op maat, moderne keuken',
  },
};
